import { Page } from '@/core/architecture'

import { ConsoleUserDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleUserDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleUserDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleUserDetailTemplate state={state} {...actions} />
}
